import { useNavigate, useParams, Navigate } from 'react-router'
import { useGame } from '../GameContext'
import { findCourse, LEGACY_COURSE_IDS } from '../data'
import { Button, Card } from '../components/ui'
import { ArrowRight, ArrowLeft } from 'lucide-react'

export default function CourseDetail() {
  const { courseId } = useParams()
  const navigate = useNavigate()
  const { setCourse } = useGame()

  const resolvedId = LEGACY_COURSE_IDS[courseId]
  if (resolvedId) {
    return <Navigate to={`/course/${resolvedId}`} replace />
  }

  const course = findCourse(courseId)

  const start = () => {
    if (course) {
      setCourse(course)
      navigate('/setup')
    }
  }

  const totalPar =
    course?.holesData?.reduce((sum, h) => sum + (h.par ?? 3), 0) ?? course?.holes * 3 ?? 0

  if (!course) {
    return (
      <div className="min-h-screen flex items-center justify-center py-6">
        <Card className="p-6 bg-card">
          <p className="text-center mb-4">Baan niet gevonden</p>
          <Button variant="outline" className="w-full" onClick={() => navigate('/')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Terug naar baan selectie
          </Button>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="flex-1 max-w-md w-full mx-auto space-y-6">
        <div className="space-y-6">
          <div className="text-center space-y-2 relative">
            <div
              className="w-28 h-28 rounded-full overflow-hidden mx-auto shadow-paper"
              style={{ backgroundColor: course.color }}
            >
              <img src={course.logo} alt={course.name} className="w-28 h-28 object-center" />
            </div>
            <h1 className="text-2xl font-hand relative z-10">Je speelt bij</h1>
            <h2 className="text-3xl text-primary font-hand relative z-10">{course.name}</h2>
            <p className="text-muted-foreground mb-2">{course.description}</p>
          </div>

          <div className="rounded-lg border border-border/60 bg-card shadow-paper-sm overflow-hidden">
            <div className="torn-edge h-2" />
            <div className="px-4 py-3 space-y-2.5">
              <div className="flex justify-between items-center">
                <span className="text-base text-muted-foreground">Holes:</span>
                <span className="text-3xl font-hand text-primary">{course.holes}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-base text-muted-foreground">Par:</span>
                <span className="text-3xl font-hand text-primary">{totalPar}</span>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Button onClick={start} className="w-full" size="lg">
              Namen invoeren
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button onClick={() => navigate('/')} variant="outline" className="w-full">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Andere baan kiezen
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
